import React from 'react';
import { Container } from '@mui/material';
import BCBAGoalGenerator from '../components/BCBAGoalGenerator';

const BCBAGoalGeneratorPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <BCBAGoalGenerator />
    </Container>
  );
};

export default BCBAGoalGeneratorPage;